module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-15-svgrepo-com.e821536b.svg";